/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromGetUserNewVideos from '../actions/user-new-videos.action';

export interface GetUserNewVideosState extends EntityState<any> {
  errorMessage: string;
  success: boolean;
  loading: boolean;
}

export const userNewVideosAdapter: EntityAdapter<any> = createEntityAdapter<any>();

export const defaultUserNewVideos: GetUserNewVideosState = {
  ids: [],
  entities: {},
  errorMessage: null,
  success: false,
  loading: false,
};

export const initialState = userNewVideosAdapter.getInitialState(defaultUserNewVideos);

export function reducer(state = initialState, action: fromGetUserNewVideos.UserNewVideosAction): GetUserNewVideosState {
  switch (action.type) {
    case fromGetUserNewVideos.LOAD_USER_NEW_VIDEOS: {
      return {
        ...state,
        ids: [],
        entities: {},
        errorMessage: null,
        loading: true,
        success: false,
      };
    }

    case fromGetUserNewVideos.LOAD_USER_NEW_VIDEOS_FAIL: {
      return {
        ...state,
        ids: [],
        entities: {},
        errorMessage: action.payload,
        loading: false,
        success: false,
      };
    }

    case fromGetUserNewVideos.LOAD_USER_NEW_VIDEOS_SUCCESS: {
      return userNewVideosAdapter.setAll(action.payload, {
        ...state,
        errorMessage: null,
        loading: false,
        success: true,
      });
    }

    case fromGetUserNewVideos.DELETE_USER_NEW_VIDEOS: {
      return {
        ...state,
        errorMessage: null,
        loading: true,
      };
    }

    case fromGetUserNewVideos.DELETE_USER_NEW_VIDEOS_SUCCESS: {
      return userNewVideosAdapter.removeOne(action.payload, {
        ...state,
        errorMessage: null,
        loading: false,
        success: true,
      });
    }

    case fromGetUserNewVideos.ADD_USER_NEW_VIDEOS: {
      return {
        ...state,
        errorMessage: null,
        loading: true,
      };
    }

    case fromGetUserNewVideos.ADD_USER_NEW_VIDEOS_SUCCESS: {
      return userNewVideosAdapter.addOne(action.payload, {
        ...state,
        errorMessage: null,
        loading: false,
        success: true,
      });
    }
  }

  return state;
}

const getUserNewVideosState = createFeatureSelector<GetUserNewVideosState>('userNewVideos');

export const getUserNewVideosData = createSelector(
  getUserNewVideosState,
  userNewVideosAdapter.getSelectors().selectAll
);

export const getUserNewVideosErrorMessage = createSelector(
  getUserNewVideosState,
  (state: GetUserNewVideosState) => state.errorMessage
);
export const getUserNewVideosLoading = createSelector(
  getUserNewVideosState,
  (state: GetUserNewVideosState) => state.loading
);
export const getUserNewVideosSuccess = createSelector(
  getUserNewVideosState,
  (state: GetUserNewVideosState) => state.success
);
